import { shouldUseMockCampaignApprovals } from '@baserow/modules/core/services/campaignApprovals'

// Force-hide legacy integrations regardless of server configuration.
export const LEGACY_VOKALIS_FEATURE_AVAILABILITY = Object.freeze({
  campaignApprovals: false,
})

export function isCampaignApprovalsAvailable(context = {}) {
  if (LEGACY_VOKALIS_FEATURE_AVAILABILITY.campaignApprovals) {
    return true
  }

  if (
    shouldUseMockCampaignApprovals({
      query: context.route?.query || context.$route?.query || {},
      localStorage:
        typeof window !== 'undefined' ? window.localStorage : null,
      env: context.$config || {},
    })
  ) {
    return true
  }

  const store = context.$store || context.store
  return !!store?.state?.vokalisIntegration?.hasToken
}
